/* st-namespace-reference="../../../src/foundations/Colors.responsive.st.css" */